import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
// service
import { createContactMessage } from "../services/Public/PublicPagesApi";
import { useTranslation } from "react-i18next";

export default function ContactForm() {
  const { t } = useTranslation("ContactForm");
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    file: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const handleFile = (e) => {
    const f = e.target.files && e.target.files[0];
    setForm((s) => ({ ...s, file: f || null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    // basic validation
    if (!form.name || !form.email || !form.message) {
      setError(t("validation_required"));
      return;
    }
    setLoading(true);
    try {
      const res = await createContactMessage({
        name: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
        file: form.file,
      });
      setSuccess(res?.message || t("send_success"));
      setForm({ name: "", email: "", subject: "", message: "", file: null });
      // reset file input value if needed (handled by rerender)
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || t("send_failed"));
      // eslint-disable-next-line no-console
      console.error("createContactMessage error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2, maxWidth: 600 }}>
      <Typography variant="h6">{t("title")}</Typography>

      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}

      <TextField label={t("name")} name="name" value={form.name} onChange={handleChange} required />
      <TextField label={t("email")} name="email" value={form.email} onChange={handleChange} required />
      <TextField label={t("subject")} name="subject" value={form.subject} onChange={handleChange} />
      <TextField
        label={t("message")}
        name="message"
        value={form.message}
        onChange={handleChange}
        multiline
        minRows={4}
        required
      />

      <input id="contact-file" type="file" onChange={handleFile} />

      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Button type="submit" variant="contained" color="primary" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : t("send")}
        </Button>
        <Button type="button" variant="outlined" onClick={() => { setForm({ name: "", email: "", subject: "", message: "", file: null }); setError(""); setSuccess(""); }} disabled={loading}>
          {t("clear")}
        </Button>
      </Box>
    </Box>
  );
}
